import React from "react";
import { Input } from "components/Input";
import { Body, Header } from "components/Table/style";
import { Table } from "../../style";

export function Phytase(props) {
  return (
    <Table>
      <Header>
        <tr>
          <th style={{ width: "185px" }}>
            <span></span>
          </th>
          <th>
            <span>Qual Produto?</span>
          </th>
        </tr>
      </Header>
      <Body>
        <tr>
          <td>Pré Postura</td>
          <td>
            <Input
              type="inputOnly"
              params="enzymes.phytase.preLay.product"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
              placeholder="Digite o Produto"
            />
          </td>
        </tr>
        <tr>
          <td>Pré Pico</td>
          <td>
            <Input
              type="inputOnly"
              params="enzymes.phytase.prePeak.product"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
              placeholder="Digite o Produto"
            />
          </td>
        </tr>
        <tr>
          <td>Pico de Postura</td>
          <td>
            <Input
              type="inputOnly"
              params="enzymes.phytase.layPeak.product"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
              placeholder="Digite o Produto"
            />
          </td>
        </tr>
        <tr>
          <td>Postura 01</td>
          <td>
            <Input
              type="inputOnly"
              params="enzymes.phytase.layFinal01.product"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
              placeholder="Digite o Produto"
            />
          </td>
        </tr>
        <tr>
          <td>Postura 02</td>
          <td>
            <Input
              type="inputOnly"
              params="enzymes.phytase.layFinal02.product"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
              placeholder="Digite o Produto"
            />
          </td>
        </tr>
        <tr>
          <td>Postura 03</td>
          <td>
            <Input
              type="inputOnly"
              params="enzymes.phytase.layFinal03.product"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
              placeholder="Digite o Produto"
            />
          </td>
        </tr>
        <tr>
          <td>Postura 04</td>
          <td>
            <Input
              type="inputOnly"
              params="enzymes.phytase.layFinal04.product"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
              placeholder="Digite o Produto"
            />
          </td>
        </tr>
        <tr>
          <td>Postura 05</td>
          <td>
            <Input
              type="inputOnly"
              params="enzymes.phytase.layFinal05.product"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
              placeholder="Digite o Produto"
            />
          </td>
        </tr>
        <tr>
          <td>Postura 06</td>
          <td>
            <Input
              type="inputOnly"
              params="enzymes.phytase.layFinal06.product"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
              placeholder="Digite o Produto"
            />
          </td>
        </tr>
      </Body>
    </Table>
  );
}
